import type { SupabaseClient } from '@supabase/supabase-js';
import supabaseClient from '../lib/supabaseClient';

export { sendRpcWithKeepalive } from '../lib/supabaseClient';

export function getSupabaseClient(): SupabaseClient {
  return supabaseClient;
}
